export const alternateArmyNames = new Map([
    /* order */
    ['Cities of Sigmar', ['COS']],
    ['Daughters of Khaine', ['DOK']],
    ['Fyreslayers', ['FS', 'Fireslayers']],
    ['Idoneth Deepkin', ['IDK']],
    ['Kharadron Overlords', ['KO']],
    ['Lumineth Realm-lords', ['LRL', 'Lumineth Realmlords', 'Lumineth Realm Lords']],
    ['Stormcast Eternals', ['SCE']],
    /* chaos */
    ['Beasts of Chaos', ['BoC']],
    ['Blades of Khorne', ['BOK']],
    ['Disciples of Tzeentch', ['DOT']],
    ['Hedonites of Slaanesh', ['HOS']],
    ['Slaves to Darkness', ['STD', 'S2D']],
    ['Skaven', ['Rat', 'Rats']],
    /* death */
    ['Flesh-eater Courts', ['FEC', 'Flesheater Courts', 'Flesh Eater Courts']],
    ['Nighthaunt', ['NH']],
    ['Ossiarch Bonereapers', ['OBR']],
    ['Soulblight Gravelords', ['SBGL']],
    ['Legions of Nagash', ['LON']],
    /* destruction */
    ['Big Waaagh!', ['BW']],
    ['Gloomspite Gitz', ['GG', 'GSG']],
    ['Ironjawz', ['IJ']],
    ['Kruleboyz', ['KB', 'KBZ']],
    ['Ogor Mawtribes', ['BCR', 'Ogors']],
    ['Sons of Behemat', ['SOB', 'Gargants']],
    ['Helsmiths of Hashut', ['HH', 'HoH', 'Chorfs']],
]);
export const alternateUnitNames = new Map([
    ['Kruleboyz Monsta-killaz', ['Monsta-Killaz']],
    ['Hobgrot Vandalz', ['Hobgrotz Vandalz']],
    [
        'Hearthguard Berzerkers with Berzerker Broadaxes',
        ['Hearthguard Berzerker with Berzerker Broadaxes'],
    ],
    [
        'Hearthguard Berzerkers with Flamestrike Poleaxes',
        ['Hearthguard Berzerker with Flamestrike Poleaxes'],
    ],
    ['Vulkite Berzerkers with Bladed Slingshields', ['Vulkite Berzerker with Bladed Slingshields']],
    ['Vulkite Berzerkers with Fyresteel Weapons', ['Vulkite Berzerker with Fyresteel Weapons']],
    ['Gelgus Pust, the Prince of Sores', ['Gelgus Pust']],
    ['Grundstok Gunhauler', ['Grundstock Gunhauler']],
    ['Plague Censer Bearers', ['Plague Censer Bearer']],
    ['Wight King on Skeletal Steed', ['Wight King on Skeleton Steed']],
    ['Knight-Judicator with Gryph-hounds', ['Knight-Judicator with Gryph Hounds']],
    ['Judicators with Boltstorm Crossbows', ['Judicator with Boltstorm Crossbows']],
    ['Savage Orruk Morboys', ['Savage Orruk Morboyz']],
    ['Kurnoth Hunters with Kurnoth Greatbows', ['Kurnoth Hunters with Greatbows']],
    ['Kurnoth Hunters with Kurnoth Greatswords', ['Kurnoth Hunters with Greatswords']],
    ['Kurnoth Hunters with Kurnoth Scythes', ['Kurnoth Hunters with Greatscythes']],
]);
export const alternateEnhancementNames = new Map([
    ['Shard of the Necris', ['Shard of Necris']],
]);
